/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ModularInputs */

const cs_enum_modular = /** @type {(inputs: Enum_ModularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulární`)
};

const en_enum_modular = /** @type {(inputs: Enum_ModularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modular`)
};

/**
* | output |
* | --- |
* | "Modular" |
*
* @param {Enum_ModularInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_modular = /** @type {((inputs?: Enum_ModularInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ModularInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_modular(inputs)
	return cs_enum_modular(inputs)
});